import { render, staticRenderFns } from "./finance_course.vue?vue&type=template&id=67156b8e&v-loading=loading&element-loading-text=%E6%AD%A3%E5%9C%A8%E5%AF%BC%E5%87%BA%E4%B8%AD&element-loading-spinner=el-icon-loading&element-loading-background=rgba(0%2C%200%2C%200%2C%200.8)"
import script from "./finance_course.vue?vue&type=script&lang=js"
export * from "./finance_course.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports